import React from 'react';
import Prescriptions from '../../Components/prescription/Prescriptions';

const PrescriptionsPage = () => {
  return (
    <>
      <Prescriptions />
    </>
  )
}

export default PrescriptionsPage;
